export default __webpack_public_path__ + "static/media/checking calculator 1.fe6c2752.png";